import { Container, Row, Col } from "react-bootstrap";
import headerImg from "../assets/img/HeroImage.png";
// import Groupdots from "../assets/img/Groupdots.svg";

export const Banner = () => {
  return (
    <section className="banner" id="home">
      {/* <img className="groupdots" src={Groupdots} alt="Header Img"></img> */}
      <Container>
        <Row className="align-items-center">
          <Col xs={12} md={6} xl={7}>
            <h1>
              Healthcare for <br></br>
              <span style={{ color: "#306AFF" }}>
                Everyone, <span className="pencilline">Everywhere</span>
              </span>
            </h1>
            <p>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam
              dignissim eros non ante molestie, id consequat est consequat.
            </p>
            <button className="button-colour">Get in Touch</button>
            <button className="button-transparent">View Departments </button>
          </Col>
          <Col xs={12} md={6} xl={5}>
            <img className="heroimage" src={headerImg} alt="Header Img"></img>
          </Col>
        </Row>
      </Container>
    </section>
  );
};
